import React from "react";
import { Gem, Plus, Pencil, Trash2, Check } from "lucide-react";

const StatusBadge = ({ u }) => {
  if (u.pendingApproval)
    return <span className="inline-flex rounded-full px-2.5 py-1 text-xs font-semibold" style={{ backgroundColor: "#3A3623", color: "#E0D286" }} data-testid={`status-pending-${u.id}`}>Pending</span>;
  if (u.isActive === false)
    return <span className="inline-flex rounded-full px-2.5 py-1 text-xs font-semibold" style={{ backgroundColor: "#3A2323", color: "#E08686" }}>Inactive</span>;
  return <span className="inline-flex rounded-full px-2.5 py-1 text-xs font-semibold" style={{ backgroundColor: "#233A2A", color: "#86E0A1" }}>Active</span>;
};

const RowActions = ({ u, currentUserId, onAward, onEdit, onDelete, onApprove }) => (
  <div className="flex items-center justify-end gap-2">
    {u.pendingApproval && (
      <button onClick={() => onApprove(u)} title="Approve account" className="inline-flex items-center gap-1 rounded-xl bg-emerald-600 text-white font-semibold text-xs px-3 py-1.5 hover:bg-emerald-500 transition-colors" data-testid={`approve-user-${u.id}`}>
        <Check className="h-3.5 w-3.5" /> Approve
      </button>
    )}
    <button onClick={() => onAward(u)} title="Award gems" className="inline-flex items-center gap-1 rounded-xl bg-vault-accent text-vault-panel font-semibold text-xs px-3 py-1.5 hover:bg-vault-accentdark transition-colors" data-testid={`award-user-${u.id}`}>
      <Plus className="h-3.5 w-3.5" /> Award
    </button>
    <button onClick={() => onEdit(u)} title="Edit user" className="inline-flex items-center gap-1 rounded-xl bg-vault-panel3 text-vault-cream font-semibold text-xs px-3 py-1.5 hover:bg-vault-panel2 transition-colors" data-testid={`edit-user-${u.id}`}>
      <Pencil className="h-3.5 w-3.5" /> Edit
    </button>
    {u.id !== currentUserId && (
      <button onClick={() => onDelete(u)} title="Delete user" className="inline-flex items-center gap-1 rounded-xl bg-red-900/40 text-red-300 font-semibold text-xs px-3 py-1.5 hover:bg-red-900/60 transition-colors" data-testid={`delete-user-${u.id}`}>
        <Trash2 className="h-3.5 w-3.5" /> Delete
      </button>
    )}
  </div>
);

export const UsersTable = ({ rows, currentUserId, canManage, onAward, onEdit, onDelete, onApprove }) => (
  <div className="rounded-3xl bg-vault-panel p-2 sm:p-4">
    <div className="overflow-x-auto">
      <table className="w-full text-sm min-w-[720px]">
        <thead>
          <tr className="text-left text-vault-subtle text-xs uppercase tracking-wider">
            <th className="py-3 px-3 font-semibold">Name</th>
            <th className="py-3 px-3 font-semibold">Email</th>
            <th className="py-3 px-3 font-semibold">Role</th>
            <th className="py-3 px-3 font-semibold">Location</th>
            <th className="py-3 px-3 font-semibold">Status</th>
            <th className="py-3 px-3 font-semibold">Gems</th>
            {canManage && <th className="py-3 px-3 font-semibold text-right">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((u) => (
            <tr key={u.id} className="border-t border-white/5" data-testid={`user-row-${u.id}`}>
              <td className="py-3.5 px-3">
                <div className="flex items-center gap-3">
                  <div className="h-8 w-8 rounded-full bg-vault-accent text-vault-panel grid place-items-center font-bold text-xs">{u.firstName[0]}{u.lastName[0]}</div>
                  <span className="text-vault-cream font-medium">{u.firstName} {u.lastName}</span>
                </div>
              </td>
              <td className="py-3.5 px-3 text-vault-subtle">{u.email}</td>
              <td className="py-3.5 px-3 text-vault-subtle">{u.role}</td>
              <td className="py-3.5 px-3 text-vault-subtle">{u.primaryLocation}</td>
              <td className="py-3.5 px-3"><StatusBadge u={u} /></td>
              <td className="py-3.5 px-3"><span className="inline-flex items-center gap-1 text-vault-cream"><Gem className="h-3.5 w-3.5 text-vault-accent" />{u.gemsBalance}</span></td>
              {canManage && (
                <td className="py-3.5 px-3">
                  <RowActions u={u} currentUserId={currentUserId} onAward={onAward} onEdit={onEdit} onDelete={onDelete} onApprove={onApprove} />
                </td>
              )}
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={canManage ? 7 : 6} className="py-10 text-center text-vault-subtle">No users match your filters.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
);
